<template>
    <v-card @click="clickListener(item)" class="headline-item" tile outlined :color="colored?'primary':''">
        <v-img aspect-ratio="1.25" v-if="image" :src="image"></v-img>
        <v-list-item two-line class="px-6">
            <v-list-item-content>
                <v-list-item-title :class="'headline my-3' + (colored?' white--text':' primary--text')">{{title}}</v-list-item-title>
                <span v-if="!image" v-html="message" :class="colored?'white--text':''"></span>
            </v-list-item-content>
        </v-list-item>
        <v-card-actions class="mt-3">
            <v-btn text :color="colored?' white':' primary'"><v-icon>mdi-arrow-right</v-icon></v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    methods: {
        clickListener() {
            //this.$emit("clickListener");
            this.$emit("click");
        }
    },
    props: {
        title: String,
        message: String,
        colored: Boolean,
        image: String,
        item: String
    }
}
</script>
<style lang="scss" scoped>
.headline-item {
    height: 100%;
}
.v-card__actions {
    position: absolute;
    bottom: 5px
}
.v-list-item__content {
    margin-bottom: 45px;
}
.v-list-item__title {
    font-size: 1.25em !important;
    line-height: normal;
    white-space: normal;
}
</style>